/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicServiceResourceBillingCategory extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicServiceResourceBillingCategory");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicServiceResourceBillingCategory>): BackgroundJobPayloadForPeriodicServiceResourceBillingCategory {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicServiceResourceBillingCategory(), model);
        BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicServiceResourceBillingCategory>): BackgroundJobPayloadForPeriodicServiceResourceBillingCategory {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.newInstance(<BackgroundJobPayloadForPeriodicServiceResourceBillingCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicServiceResourceBillingCategory) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicServiceResourceBillingCategory): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
